import { Injectable } from '@angular/core';
import { Router, RoutesRecognized, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import './operators';

import * as _ from 'lodash';
import {filter, pairwise} from 'rxjs/operators';


class AppRoutingModel {
  previousRoute: string = '';
  state: RouterStateSnapshot = null;
  urlAfterRedirects: string = '';
  // notReturnBackToRoutes are needed to describe for different pages
  // routes which are not allowed to save as previousRoute
  notReturnBackToRoutes: any = {};
}


@Injectable()
export class AppRoutingService {

  model = new BehaviorSubject<AppRoutingModel>(new AppRoutingModel());

  constructor(
    private router: Router,
  ) {
    this.router.events
    .pipe(
        filter(e => e instanceof RoutesRecognized),
        pairwise()
    )
    .subscribe((e: any[]) => {
      const model: AppRoutingModel = this.model.getValue();
      const urlFrom = e[0].urlAfterRedirects;
      const urlTo = e[1].urlAfterRedirects;

      // this variable shows if urlFrom is allowed to save as
      // previousRoute for urlTo (current url)
      let isAllowToSavePreviousRoute = true;

      // check wheter urlFrom is allowed to save
      if (model.previousRoute) {
        const rootRouteTo = this.getRootRoute(urlFrom);
        isAllowToSavePreviousRoute = !_.some(this.notReturnBackToRoutes[rootRouteTo], (route: string) => {
          return urlFrom.match(route);
        });
      }

      // then save if it's allows
      if (isAllowToSavePreviousRoute) {
        model.urlAfterRedirects = urlFrom;
        model.previousRoute = urlFrom;
        model.state = e[0].state;
        this.model.next(model);
      } else {
        model.urlAfterRedirects = urlFrom;
        model.state = e[0].state;
        this.model.next(model);
      }
    });
  }

  public get previousRoute(): string {
    return this.model.getValue().previousRoute;
  }

  public get state(): RouterStateSnapshot {
    return this.model.getValue().state;
  }

  public get notReturnBackToRoutes(): any {
    return this.model.getValue().notReturnBackToRoutes;
  }

  public get urlAfterRedirects(): string {
    return this.model.getValue().urlAfterRedirects;
  }

  public setNotReturnBackToRoutes(fieldName: string, notReturnBackToRoutes: Array<string>) {
    const model = this.model.getValue();
    model.notReturnBackToRoutes[fieldName] = notReturnBackToRoutes;
    this.model.next(model);
  }

  // private
  private getRootRoute(url: string) {
    const urlSplitted = url.split('/');
    return urlSplitted.length > 1 ? urlSplitted[1] : null;
  }
}
